

export default function(state = {}, action){
  if (action.type == 'ADD_ORGANIZATION'){
    var org = action.organization
    state = Object.assign({}, state)
    state[org.id] = org
  }
  return state
}


// WEBPACK FOOTER //
// ./src/store/organizations/reducer.js